import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/no-ga/src/app/[locale]/(site)/service/side-menu.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/cookies-next@6.1.1_next@15.5.9_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+_66c5b4dae7f04cee77610a920d9144bd/node_modules/cookies-next/lib/client/context.js");
